document.addEventListener('DOMContentLoaded', function() {

  const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
      }, wait);
    };
  }


  if (window.innerWidth < 768) {
    console.log('setting up');
    let anim = gsap.timeline();

    if (document.querySelector('buy-button')) {
      anim.set('buy-button a', {'display': 'flex'});
      anim.to('buy-button a', {opacity: 0, duration: 0.4});
      anim.set('buy-button a', {'display': 'none'});
    }
    // buy button - buy section
    if (document.querySelector('product-info')) {
      ScrollTrigger.create({
        markers: false,
        trigger: 'product-info',
        start: 'top bottom',
        end: 'bottom bottom-=100',
        toggleActions: "play reverse play reverse",
        animation: anim
      });
    }
    // buy button - footer
    ScrollTrigger.create({
      trigger: 'footer.footer',
      start: 'top bottom',
      end: 'bottom bottom-=500',
      toggleActions: "play reverse play reverse",
      animation: anim
    });


    if (document.querySelector('type-tester-wrapper')) {
      let anim2 = gsap.timeline();
      anim2.set('type-tester-wrapper', {'display': 'block'});
      anim2.to('type-tester-wrapper', {opacity: 0, duration: 0.4});
      anim2.set('type-tester-wrapper', {'display': 'none'});
      ScrollTrigger.create({
        trigger: 'product-info',
        start: 'top top',
        end: 'bottom top',
        toggleActions: "play reverse play reverse",
        animation: anim2
      });
    }


    if (document.querySelector('.collection-product-grid-action-container--fixed')) {
      let anim3 = gsap.timeline();
      anim3.set('.collection-product-grid-action-container--fixed', {display: 'block'});
      anim3.to('.collection-product-grid-action-container--fixed', {opacity: 0, duration: 0.4});
      anim3.set('.collection-product-grid-action-container--fixed', {display: 'none'});
      ScrollTrigger.create({
        trigger: 'footer.footer',
        start: 'top bottom',
        end: 'bottom top',
        toggleActions: "play reverse play reverse",
        animation: anim3
      });
    }


  } else {
    if (document.querySelector('product-info')) {
      let anim = gsap.timeline();
      anim.set('buy-button a', {'display': 'flex'});
      anim.set('type-tester-wrapper', {'display': 'block'});
      anim.to('buy-button a', {opacity: 0, duration: 0.4});
      anim.to('type-tester-wrapper', {opacity: 0, duration: 0.4}, '-=0.4');
      anim.set('buy-button a', {'display': 'none'});
      anim.set('type-tester-wrapper', {'display': 'none'});

      ScrollTrigger.create({
        trigger: 'product-info',
        start: 'top top+=100',
        end: 'bottom top',
        toggleActions: "play reverse play reverse",
        animation: anim
      });
    }

  }


// hideBuyButton() {
  // if (window.innerWidth < 768) {
  //   console.log('setting up');
  //   // buy button - buy section
  //   ScrollTrigger.create({
  //     trigger: 'product-info',
  //     start: 'top bottom',
  //     end: 'bottom bottom-=100',
  //     toggleActions: "play reverse none none",
  //     onToggle: (self) => {
  //       console.log('Buy Button - toggled, isActive:', self.isActive)
  //       if (self.isActive) {
  //         gsap.to('buy-button a', {
  //           opacity: 0, duration:0.4, onComplete: function() {
  //             gsap.set('buy-button a', {'display': 'none'})
  //           }
  //         });
  //       } else {
  //         gsap.set('buy-button a', {'display': 'flex'})
  //         gsap.to('buy-button a', {
  //           opacity: 1, duration:0.4,onComplete: function() {
  //           }
  //         });
  //       }
  //     }
  //   });
  //   // buy button - footer
  //   ScrollTrigger.create({
  //     trigger: 'footer.footer',
  //     start: 'top bottom',
  //     end: 'bottom bottom-=500',
  //     toggleActions: "play reverse none none",
  //     onToggle: (self) => {
  //       console.log('Buy Button - toggled, isActive:', self.isActive)
  //       if (self.isActive) {
  //         gsap.to('buy-button a', {
  //           opacity: 0, duration:0.4, onComplete: function() {
  //             gsap.set('buy-button a', {'display': 'none'})
  //           }
  //         });
  //       } else {
  //         gsap.set('buy-button a', {'display': 'flex'})
  //         gsap.to('buy-button a', {
  //           opacity: 1, duration:0.4,onComplete: function() {
  //           }
  //         });
  //       }
  //     }
  //   });
  //   ScrollTrigger.create({
  //     trigger: 'product-info',
  //     start: 'top top',
  //     end: 'bottom top',
  //     toggleActions: "play reverse none none",
  //     onToggle: (self) => {
  //       console.log('Type Tester - toggled, isActive:', self.isActive)
  //       if (self.isActive) {
  //         gsap.to('type-tester-wrapper', {
  //           opacity: 0, duration:0.4,onComplete: function() {
  //             gsap.set('type-tester-wrapper', {'display': 'none'})
  //           }
  //         });

  //       } else {
  //         gsap.set('type-tester-wrapper', {'display': 'block'})
  //         gsap.to('type-tester-wrapper', {
  //           opacity: 1, duration:0.4,onComplete: function() {
  //           }
  //         });
  //       }
  //     }
  //   });
  // } else {
  //   ScrollTrigger.create({
  //     trigger: 'product-info',
  //     start: 'top top+=100',
  //     end: 'bottom top',
  //     toggleActions: "play reverse none none",
  //     onToggle: (self) => {
  //       console.log('toggled, isActive:', self.isActive)
  //       if (self.isActive) {
  //         console.log('active buy form');
  //         gsap.to('buy-button a', {
  //           opacity: 0, duration:0.4,onComplete: function() {
  //             gsap.set('buy-button a', {'display': 'none'})
  //           }
  //         });
  //         gsap.to('type-tester-wrapper', {
  //           opacity: 0, duration:0.4,onComplete: function() {
  //             gsap.set('type-tester-wrapper', {'display': 'none'})
  //           }
  //         });

  //       } else {
  //         gsap.set('buy-button a', {'display': 'flex'})
  //         gsap.to('buy-button a', {
  //           opacity: 1, duration:0.4,onComplete: function() {
  //           }
  //         });
  //         gsap.set('type-tester-wrapper', {'display': 'block'})
  //         gsap.to('type-tester-wrapper', {
  //           opacity: 1, duration:0.4,onComplete: function() {
  //           }
  //         });
  //       }
  //     }
  //   });

  // }

  // }


  class FontAnimation extends HTMLElement {
    constructor() {
      super();


      let width = this.offsetWidth;
      let height = this.offsetHeight;
      // console.log(width);
      let dontscale = false;
      if (this.querySelector('.c--svg-animation-box')) {
        // console.log(this.querySelector('.c--svg-animation-box').dataset.dontScale);
        if (this.querySelector('.c--svg-animation-box').dataset.dontScale == 'true') {
          dontscale = true;
        }
      }
      // console.log(dontscale);
      let imageToRotate = this.querySelector('media-row-image');
      // this.addEventListener('mousemove', function(e) {
      //   var rect = e.target.getBoundingClientRect();
      //   var x = e.clientX - rect.left - width / 2; //x position within the element.
      //   var y = e.clientY - rect.top - height / 2;  //y position within the element.

      //   let xPercent = x / width;
      //   let yPercent = y / height;
      //   gsap.to(e.target, {rotateX: xPercent * 30, rotateY: -yPercent * 30});
      // })

      window.addEventListener("resize", () => {
        if (!dontscale) {
          this.scaleFont();
        } else {
          this.sizeParentBox();
        }
      });

      document.fonts?.ready.then(() => {
        if (!dontscale) {
          this.scaleFont();
        } else {
          this.sizeParentBox();
        }
        // ScrollTrigger.refresh();
      });

      this.querySelectorAll('.c--svg-animation-box').forEach((element, index) => {
        if (index == 0) {
          element.classList.remove('absolute');
          element.classList.add('relative');
        }
      });


      // this.sizeParentBox();

      this.animateFont();


      if (this.dataset.cursor) {
        this.wrapWithTooltip();
      }
      // ScrollTrigger.refresh();
    }

    wrapWithTooltip() {
      // Create media-row-image element
      const tooltipWrapper = document.createElement('media-row-image');
      tooltipWrapper.dataset.text = this.dataset.text;
      tooltipWrapper.dataset.svg = this.dataset.svg;

      // Move all children into the tooltip wrapper
      while (this.firstChild) {
        tooltipWrapper.appendChild(this.firstChild);
      }

      // Append the wrapper back to this element
      this.appendChild(tooltipWrapper);
    }

    sizeParentBox() {
      this.querySelectorAll('.c--svg-animation-box--text').forEach((element, index) => {
        if (index == 0) {
          // console.log(element.querySelector('.product-title'));
          // console.log(element.querySelector('.product-title').offsetHeight);
          gsap.set(element, {height: element.querySelector('.product-title').offsetHeight});
          gsap.set(element.parentNode, {height: element.querySelector('.product-title').offsetHeight});
        }
      });
    }

    animateFont() {
      this.querySelectorAll('.product-link').forEach((element, index) => {
        if (index != 0) {
          element.classList.add('invisible');
        } else {
          element.classList.remove('invisible');
        }
      });
      let length = this.querySelectorAll('.product-link').length;
      let i = 0;

      let that = this;
      setInterval(() => {
        that.querySelectorAll('.product-link')[i].classList.remove('invisible');
        that.querySelectorAll('.product-link').forEach((element, index) => {
          if (index != i) {
            element.classList.add('invisible');
          }
        });

        if (i < length - 1) {
          i++;
        } else {
          i = 0;
        }
      }, this.dataset.speed);
    }

    scaleFont() {
      // console.log('SCALING');
      // this.querySelectorAll('.product-link').forEach((el) => {
      let el = this.querySelector('.product-link');
      const slideEl = el;
      const textEl = el.querySelector(".product-link .product-title");
      const textElP = el.querySelector(".product-link .product-title p");

      if (slideEl && textEl) {
        //   const isMultiWord = this.dataset.multiWord === "true";
        //   if (isMultiWord) {
        //     textEl.style.opacity = "1";
        //     return;
        //   }

        var computedStyle = getComputedStyle(slideEl);

        let slideElHeight = slideEl.clientHeight; // height with padding
        let slideElWidth = slideEl.clientWidth; // width with padding
        slideElHeight -=
          parseFloat(computedStyle.paddingTop) +
          parseFloat(computedStyle.paddingBottom);
        slideElWidth -=
          parseFloat(computedStyle.paddingLeft) +
          parseFloat(computedStyle.paddingRight);

        let textElHeight = textEl.clientHeight;
        let textElWidth = textEl.clientWidth;

        const scaleHeight = slideElHeight / textElHeight;
        const scaleWidth = slideElWidth / textElWidth;

        const scale = Math.min(scaleHeight, scaleWidth);

        const fontSize = parseFloat(
          getComputedStyle(textEl).getPropertyValue("font-size")
        );
        const newFontSize = Math.floor(fontSize * scale - 5);

        // textEl.style.transform = `scale(${scale})`;
        textEl.style.fontSize = newFontSize + "px";
        textElP.style.fontSize = newFontSize + "px";
        textEl.style.opacity = "1";
        this.querySelectorAll('.product-title').forEach((el) => {
          el.style.fontSize = newFontSize + "px";
          el.querySelector('p').style.fontSize = newFontSize + "px";
          el.style.opacity = "1";
        });
      }
      // })
      // this.sizeParentBox();
    }
  }

  customElements.define("font-animation", FontAnimation);

  class MediaRowImage extends HTMLElement {
    constructor() {
      super();


      //  this.targetElement = typeof targetElement === 'string'
      //         ? document.querySelector(targetElement)
      //         : targetElement;

      // if (!this.targetElement) {
      //     console.error('CursorTracker: Target element not found');
      //     return;
      // }
      let fontName = this.dataset['text'];


      if (this.querySelector('video')) {
        var video = this.querySelector('video');
        console.log(video);
        video.muted = true;
        video.play();
      }
      // Default options
      this.options = {
        text: fontName,
        showCoordinates: true,
        offsetX: 15,
        offsetY: -15,
        className: 'cursor-tracker-box',
        throttleDelay: 0,
        onMove: null,
        onEnter: null,
        onLeave: null,
        customContent: null
      };

      // Create the tooltip element
      if (fontName != undefined && fontName != '') {
        // console.log(fontName);
        // console.log('BINDING');
        this.createTooltip();

        // Bind events
        this.bindEvents();

        // Store position data
        this.position = {x: 0, y: 0, relativeX: 0, relativeY: 0};
      }
    }

    createTooltip() {
      // Create tooltip element
      this.tooltip = document.createElement('img');
      this.tooltip.src = this.dataset['svg'];
      this.tooltip.className = this.options.className;
      this.tooltip.style.cssText = `
            position: fixed;
            background-color: rgba(0, 0, 0, 0.6);
            backdrop-filter:blur(10px);
            color: white;
            padding: 18px 44px;
            line-height:1;
            border-radius: 44px;
            font-size: 50px;
            font-family: ${this.dataset['text']} ;
            pointer-events: none;
            z-index: 9999;
            display: none;
            box-shadow: 0 2px 10px rgba(0,0,0,0.3);
            white-space: nowrap;
            transition: opacity 0.2s ease;
        `;

      // Add to body
      document.body.appendChild(this.tooltip);
    }

    updateTooltip(e) {
      // Get element bounds
      const bounds = this.getBoundingClientRect();

      // Calculate positions
      this.position.x = e.clientX;
      this.position.y = e.clientY;
      this.position.relativeX = e.clientX - bounds.left;
      this.position.relativeY = e.clientY - bounds.top;

      // Update tooltip position
      let tooltipX = this.position.x + this.options.offsetX;
      let tooltipY = this.position.y + this.options.offsetY;

      // Update tooltip content
      // let content = this.options.text;
      // console.log(content);
      // if (this.options.customContent) {
      //     content = this.options.customContent(this.position, bounds);
      // } else if (this.options.showCoordinates) {
      //     content = `${this.options.text}: (${Math.round(this.position.relativeX)}, ${Math.round(this.position.relativeY)})`;
      // }

      this.tooltip.innerHTML = this.options.text;

      // Position the tooltip
      this.tooltip.style.left = tooltipX + 'px';
      this.tooltip.style.top = tooltipY + 'px';

      // Check if tooltip goes off-screen and adjust
      const tooltipBounds = this.tooltip.getBoundingClientRect();

      if (tooltipBounds.right > window.innerWidth) {
        tooltipX = this.position.x - tooltipBounds.width - Math.abs(this.options.offsetX);
        this.tooltip.style.left = tooltipX + 'px';
      }

      if (tooltipBounds.bottom > window.innerHeight) {
        tooltipY = this.position.y - tooltipBounds.height - Math.abs(this.options.offsetY);
        this.tooltip.style.top = tooltipY + 'px';
      }

      // Call custom onMove callback if provided
      if (this.options.onMove) {
        this.options.onMove(this.position, bounds, this.tooltip);
      }
    }

    handleMouseEnter(e) {
      let that = this;
      let hoveredElement = null;

      // console.log('MOUSE ENTERING');
      this.tooltip.style.display = 'block';
      this.tooltip.style.opacity = '0';


      this.boundDocMouseMove = (e) => {
        // console.log('doc move');
        const hoveredElement = document.elementFromPoint(e.clientX, e.clientY);
        if (!that.contains(hoveredElement)) {
          that.tooltip.style.opacity = '0';
          setTimeout(() => {
            that.tooltip.style.display = 'none';
          }, 200);
          // Remove listener once we've left the element
          document.removeEventListener('mousemove', that.boundDocMouseMove);
        }
      };

      document.addEventListener('mousemove', this.boundDocMouseMove);

      // Small delay for smooth appearance
      setTimeout(() => {
        this.tooltip.style.opacity = '1';
      }, 10);

      this.updateTooltip(e);

      if (this.options.onEnter) {
        this.options.onEnter(e, this.tooltip);
      }
    }

    handleMouseMove(e) {
      // console.log('MOUSE MOVING');
      if (this.options.throttleDelay > 0) {
        if (!this.throttleTimer) {
          this.throttleTimer = setTimeout(() => {
            this.updateTooltip(e);
            this.throttleTimer = null;
          }, this.options.throttleDelay);
        }
      } else {
        this.updateTooltip(e);
      }
    }

    handleMouseLeave(e) {
      // console.log('MOUSE LEAIVNG');
      this.tooltip.style.opacity = '0';

      setTimeout(() => {
        this.tooltip.style.display = 'none';
      }, 200);

      // Clean up the document listener if it's still attached
      if (this.boundDocMouseMove) {
        document.removeEventListener('mousemove', this.boundDocMouseMove);
        this.boundDocMouseMove = null;
      }

      if (this.options.onLeave) {
        this.options.onLeave(e, this.tooltip);
      }
    }

    bindEvents() {
      // Bind event handlers
      this.boundMouseEnter = this.handleMouseEnter.bind(this);
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.boundMouseLeave = this.handleMouseLeave.bind(this);

      if (!("ontouchstart" in document.documentElement)) {

        // Add event listeners
        this.addEventListener('mouseenter', this.boundMouseEnter);
        this.addEventListener('mousemove', this.boundMouseMove);
        this.addEventListener('mouseleave', this.boundMouseLeave);
      }
    }

  }

  customElements.define("media-row-image", MediaRowImage);


  class HeaderEazy extends HTMLElement {
    constructor() {
      super();
      // gsap.to(this.querySelector('header'), { x: 200 })
      this.desktopHeader = this.querySelector('.js--header-menu__desktop');
      this.desktopButton = this.querySelector('.js--header-menu__desktop__button');

      this.mobileHeader = this.querySelector('.js--header-menu__mobile');
      this.mobileButton = this.querySelector('.js--header-menu__mobile__button');

      this.headerText = this.querySelector('.js--header-menu__menu');
      this.headerFonts = this.querySelector('.js--header-menu__fonts');

      this.headerFull = this.querySelector('.js--header-full');

      this.headerFullCart = this.querySelector('.js--header-full-cart');
      this.headerFullCartCloseButton = this.querySelector('.js--header-full-cart__close');

      let that = this;


      this.bindOutsideClick = this.clickOutsideMenu.bind(this);
      this.bindOutsideClickMobile = this.clickOutsideMenuMobile.bind(this);

      this.headerFullCartCloseButton.addEventListener('click', function() {
        that.closeCart();
      })

      this.desktopButton.addEventListener('click', function() {
        if (that.classList.contains('open')) {
          that.closeDesktopMenu();
        } else {
          if (that.headerFullCart.classList.contains('open')) {
            that.closeCart();
          }
          if (document.querySelector('type-tester-wrapper')) {
            gsap.to('type-tester-wrapper', {
              opacity: 0, onComplete: function() {
                document.querySelector('type-tester-wrapper').classList.add('hidden');
              }
            })
          }
          if (!document.querySelector('.js--cart-message').classList.contains('hidden')) {
            document.querySelector('.js--cart-close ').click();
          }
          that.classList.add('open');
          gsap.to(that.headerText, {x: 0, duration: 0.6});

          gsap.to(that.headerFonts, {
            y: 0, duration: 0.6, onComplete: function() {
              document.addEventListener('click', that.bindOutsideClick);
            }
          });
          // that.querySelector('.js--header-menu__desktop__button__open').classList.add('hidden');
          // that.querySelector('.js--header-menu__desktop__button__close').classList.remove('hidden');

          gsap.to(that.querySelector('.menu-svg-top'), {y: '4px'});
          gsap.to(that.querySelector('.menu-svg-top'), {rotationZ: 45, transformOrigin: '50% 50%'});
          gsap.to(that.querySelector('.menu-svg-bottom'), {y: '-4px'});
          gsap.to(that.querySelector('.menu-svg-bottom'), {rotationZ: -45, transformOrigin: '50% 50%'});

        }
      })

      this.mobileButton.addEventListener('click', function() {

        if (that.classList.contains('open')) {
          that.closeMobileMenu();
          // document.body.classList.remove('overflow-hidden');
        } else {
          if (that.headerFullCart.classList.contains('open')) {
            that.closeCart();
          }
          if (document.querySelector('type-tester-wrapper')) {
            gsap.to('type-tester-wrapper', {
              opacity: 0, duration: 0, onComplete: function() {
                document.querySelector('type-tester-wrapper').classList.add('hidden');
              }
            })
          }
          that.classList.add('open');
          gsap.to(that.headerText, {x: 0, duration: 0.6});
          gsap.to(that.headerFonts, {
            y: 0, duration: 0.6, onComplete: function() {
              document.addEventListener('click', that.bindOutsideClickMobile);
            }
          });
          // that.querySelector('.js--header-menu__mobile__button__open').classList.add('hidden');
          // that.querySelector('.js--header-menu__mobile__button__close').classList.remove('hidden');
          gsap.to(that.querySelector('.js--header-menu__mobile .menu-svg-top'), {y: '4px'});
          gsap.to(that.querySelector('.js--header-menu__mobile .menu-svg-top'), {rotationZ: 45, transformOrigin: '50% 50%'});
          gsap.to(that.querySelector('.js--header-menu__mobile .menu-svg-bottom'), {y: '-4px'});
          gsap.to(that.querySelector('.js--header-menu__mobile .menu-svg-bottom'), {rotationZ: -45, transformOrigin: '50% 50%'});
        }
      })
    }

    clickOutsideMenu(e) {
      let that = this;
      if (that.classList.contains('open') && e.target.href === undefined && (!(that.desktopButton.contains(e.target)) || !(that.headerText.contains(e.target) || that.headerFonts.contains(e.target)))) {
        that.closeDesktopMenu();
      }
    }

    clickOutsideMenuMobile(e) {
      console.log('click outside mobile');
      console.log(e.target);
      let that = this;
      if ((that.classList.contains('open')) && (e.target.href === undefined) && (!(that.mobileButton.contains(e.target)) && (!(that.headerText.contains(e.target))) && (!that.headerFonts.contains(e.target)))) {
        console.log('closing');
        console.log(e.target);
        console.log(that.headerFonts.contains(e.target));
        that.closeMobileMenu();
      }
    }

    closeDesktopMenu() {
      let timeline = gsap.timeline();
      document.removeEventListener('click', this.bindOutsideClick);


      if (window.innerWidth > 640) {
        gsap.to(this.headerText, {x: '-100%', duration: 0.6});
        gsap.to(this.headerFonts, {
          y: '100%', duration: 0.6, onComplete: function() {
            // We show the type tester again
            if (document.querySelector('type-tester-wrapper')) {
              document.querySelector('type-tester-wrapper').classList.remove('hidden');
              gsap.to('type-tester-wrapper', {opacity: 1});
            }
          }
        });
        // this.querySelector('.js--header-menu__desktop__button__open').classList.remove('hidden');
        // this.querySelector('.js--header-menu__desktop__button__close').classList.add('hidden');
        gsap.to(this.querySelector('.menu-svg-top'), {y: '0px'});
        gsap.to(this.querySelector('.menu-svg-top'), {rotationZ: 0, transformOrigin: '50% 50%'});
        gsap.to(this.querySelector('.menu-svg-bottom'), {y: '0'});
        gsap.to(this.querySelector('.menu-svg-bottom'), {rotationZ: 0, transformOrigin: '50% 50%'});
      }
      this.classList.remove('open');
    }

    closeMobileMenu() {

      // document.body.classList.remove('overflow-hidden');
      // let timeline = gsap.timeline();
      // timeline.to(this.headerFull, {'clip-path': 'inset(100% 0% 0% 0%)', duration: 1});
      // if (window.innerWidth > 640) {
      //   timeline.to(this.desktopButton, {top: '16px', left: '17px', duration: 0.4}, '-=0.4');
      // }
      document.removeEventListener('click', this.bindOutsideClickMobile);
      gsap.to(this.headerText, {x: '-100%', duration: 0.6});
      gsap.to(this.headerFonts, {
        y: '-100%', duration: 0.6, onComplete: function() {
          // We show the type tester again
          if (document.querySelector('type-tester-wrapper')) {
            document.querySelector('type-tester-wrapper').classList.remove('hidden');
            gsap.to('type-tester-wrapper', {opacity: 1});
          }
        }
      });
      // this.querySelector('.js--header-menu__mobile__button__open').classList.remove('hidden');
      // this.querySelector('.js--header-menu__mobile__button__close').classList.add('hidden');
      gsap.to(this.querySelector('.js--header-menu__mobile .menu-svg-top'), {y: '0px'});
      gsap.to(this.querySelector('.js--header-menu__mobile .menu-svg-top'), {rotationZ: 0, transformOrigin: '50% 50%'});
      gsap.to(this.querySelector('.js--header-menu__mobile .menu-svg-bottom'), {y: '0'});
      gsap.to(this.querySelector('.js--header-menu__mobile .menu-svg-bottom'), {rotationZ: 0, transformOrigin: '50% 50%'});
      this.classList.remove('open');
    }

    closeCart() {
      this.headerFullCart.classList.remove('open');
      gsap.to(this.headerFullCart, {x: '100%', duration: 0.6});
    }


  }

  customElements.define("header-eazy", HeaderEazy);


  class BuyButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', function(e) {

        this.scrollToBuyForm(e, "smooth");
        document.querySelector('.js--close-type-tester').click();
      })
    }

    scrollToBuyForm(e, behavior = "smooth") {
      const element = document.querySelector("product-info");
      if (!element) {
        return;
      }

      e.preventDefault();

      if (window.innerWidth > 767) {
        element.scrollIntoView({block: "start", behavior: behavior});

        // for ios
        const container = document.querySelector("body");
        const top = element.offsetTop - container.offsetTop;
        container.scrollTo({top, behavior});
      } else {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset + 75;

        window.scrollTo({
          top: offsetPosition,
          behavior: behavior,
        });

        // for ios
        const container = document.querySelector("body");
        const top = element.offsetTop - container.offsetTop + 75;
        container.scrollTo({top, behavior});
      }
    }
  }

  customElements.define("buy-button", BuyButton);


  class FontList extends HTMLElement {

    constructor() {
      super();
      // console.log('font list');
      let viewport = this;
      // console.log(document.querySelectorAll('.c--font-list-viewport__inner')[1].offsetTop);
      let viewportInner = document.querySelectorAll('.c--font-list-viewport')[0];

      let offsetSecond = document.querySelectorAll('.c--font-list-viewport__inner')[1].offsetTop;
      // document.addEventListener("DOMContentLoaded", (event) => {
      gsap.registerPlugin(ScrollTrigger)
      gsap.registerPlugin(ScrollToPlugin)

      setInterval(function() {
        viewportInner.scrollTop = viewportInner.scrollTop + 1;
      }, 30);

      // let timeline = gsap.timeline({repeat:-1});

      // timeline.to(viewportInner, {duration: 2, ease:"linear", scrollTo: { y: viewportInner.offsetTop + 10}});
      ScrollTrigger.create({
        start: 0,
        scroller: viewport,
        end: "max",
        onUpdate: self => {
          // console.log(self.progress);
          if (self.progress > 0.999) {
            let heightViewport = viewport.offsetHeight;
            // console.log(offsetSecond - heightViewport);
            self.scroll(offsetSecond - heightViewport);
          }
        },
        onLeaveBack: self => {
          // console.log('leavback');
          // self.scroll(ScrollTrigger.maxScroll(window)-1);
          // ScrollTrigger.update();
          self.scroll(offsetSecond);
        }
      });
      // });

// ScrollTrigger.refresh();
    }
  }

  customElements.define("font-list", FontList);


  class FilterToggle extends HTMLElement {

    constructor() {
      super();
      let that = this;
      this.closeIcon = this.querySelector('.js--close');
      this.openIcon = this.querySelector('.js--open');
      console.log('helloss');
      this.querySelector('button').addEventListener('click', function(el) {
        if (this.classList.contains('open')) {
          this.classList.remove('open');
          that.closeIcon.classList.add('hidden');
          that.openIcon.classList.remove('hidden');
          // gsap.to('.c--facets-menu', {'clip-path': 'inset(0% 0% 100% 0%)', duration: 1});
          gsap.to('.c--facets-menu-wrapper', {x: '100%', duration: 0.7});
        } else {

          if (document.querySelector('.js--text-swatch').classList.contains('open')) {
            document.querySelector('.js--text-swatch').click();
          }

          if (document.querySelector('.js--swatch').classList.contains('open')) {
            document.querySelector('.js--swatch').click();
          }
          this.classList.add('open');
          that.openIcon.classList.add('hidden');
          that.closeIcon.classList.remove('hidden');
          // gsap.to('.c--facets-menu', {'clip-path': 'inset(0% 0% 0% 0%)', duration: 1});
          gsap.to('.c--facets-menu-wrapper', {x: '0%', duration: 0.7});
        }
      })

      document.querySelectorAll('filter-font-types-v2 .font-type').forEach(function(button) {
        button.addEventListener('click', function() {
          document.querySelectorAll('filter-font-types-v2 .font-type').forEach(function(button2) {
            button2.classList.remove('bg-black', 'text-white');
          });
          if (button.dataset.type != 'All') {
            button.classList.add('bg-black', 'text-white');
          }
          gsap.to('.card-wrapper', {
            opacity: 0, scale: 0.8, duration: 0.25,
            onComplete: function() {
              // console.log(button.dataset.type);
              let selectedType = button.dataset.type;
              document.querySelectorAll('card-product').forEach(function(card) {
                let types = JSON.parse(card.dataset.type);
                // console.log(types);
                if (types.includes(selectedType)) {
                  card.parentNode.parentNode.classList.remove('hidden');
                } else {
                  card.parentNode.parentNode.classList.add('hidden');
                }
              })
              window.dispatchEvent(new Event("card-product:scale-product-title"));
              // that.scaleText();
              gsap.to('.card-wrapper', {
                opacity: 1, scale: 1, duration: 0.25
              });
            }

          });


        })
      })

    }

    scaleText() {
      // alert('hey');
      const el = this.querySelector(".product-title");
      if (el.style.fontSize) {
        // console.log("Inline font-size exists:", el.style.fontSize);
        // return;
      } else {
        // console.log("No inline font-size");
      }

      const cardParentContainer = this.closest("ul");
      const cardMinHeight = parseFloat(cardParentContainer.dataset.cardMinHeight);
      const cardMinHeightMobile = parseFloat(
        cardParentContainer.dataset.cardMinHeightMobile
      );

      const cardEl = this.querySelector(".card");
      if (window.innerWidth > 767) {
        cardEl.style.minHeight = cardMinHeight + "px";
      } else {
        cardEl.style.minHeight = cardMinHeightMobile + "px";
      }

      const slideEl = this.querySelector(".card__inner");
      const textEl = this.querySelector(".card__inner .product-title");

      textEl.spellcheck = false;

      const scaleFontSizeUpTo = parseInt(slideEl.dataset.scaleFontSizeUpTo);

      if (slideEl && textEl) {

        /* NEW */
        let newFontSize = parseFloat(window.getComputedStyle(textEl).fontSize);

        newFontSize = this.fitTextToParent(textEl, slideEl);

        textEl.style.opacity = "1";

        let maxTextSize = newFontSize + (newFontSize - 16);
        if (maxTextSize < 60) {
          maxTextSize = 60;
        }

        if (window.innerWidth > 767) {
          maxTextSize = newFontSize + scaleFontSizeUpTo;
        }
      }
      // ScrollTrigger.refresh();
    }
  }

  customElements
    .define(
      "filter-toggle"
      ,
      FilterToggle
    )
  ;


  class ColorToggle
    extends HTMLElement {

    constructor() {
      super();
      let that = this;
      this.closeIcon = this.querySelector('.js--close');
      this.openIcon = this.querySelector('.js--open');
      // console.log('helloss');
      this.querySelector('button').addEventListener('click', function(el) {
        if (this.classList.contains('open')) {
          this.classList.remove('open');
          that.closeIcon.classList.add('hidden');
          that.openIcon.classList.remove('hidden');

          document.querySelectorAll('.card-wrapper').forEach((card) => {
            let backgroundColor = card.dataset.backgroundColor;
            let textColor = card.dataset.textColor;
            // gsap.to(card, {clearProps:'backgroundColor', duration:0});
            // gsap.to(card.querySelector('.product-title'), {clearProps:'color', duration:0});
            gsap.to(card, {backgroundColor: '#F6F6F6A6', duration: 0});
            gsap.to(card.querySelector('.product-title'), {color: 'black', duration: 0});
          })

        } else {
          this.classList.add('open');
          document.querySelectorAll('.card-wrapper').forEach((card) => {
            let backgroundColor = card.dataset.backgroundColor;
            let textColor = card.dataset.textColor;
            gsap.to(card, {backgroundColor: backgroundColor, duration: 0});
            gsap.to(card.querySelector('.product-title'), {color: textColor, duration: 0});
          })

          that.openIcon.classList.add('hidden');
          that.closeIcon.classList.remove('hidden');
        }
      })
    }
  }

  customElements.define("color-toggle", ColorToggle);

class HeaderCart extends HTMLElement {

  constructor() {
    super();
    console.log('constructing');
    let that = this;
    // this.closeIcon = this.querySelector('.js--close');
    // this.openIcon = this.querySelector('.js--open');
    this.message = this.querySelector('.js--cart-message');
    this.closeButton = this.querySelector('.js--cart-close');

    this.cartButton = this.querySelector('.header__icon--cart');
    // console.log(this.cartButton);

    this.headerFullCart = document.querySelector('.js--header-full-cart');


    this.bindOutsideClick = this.clickOutsideCart.bind(this);

    this.querySelector('a').addEventListener('click', function(el) {
      el.preventDefault();
      if (that.querySelector('.js--cart-count').innerHTML == '') {

        if (document.querySelector('header-eazy').classList.contains('open')) {
          document.querySelector('.js--header-menu__desktop__button').click();
        }
        that.message.classList.remove('hidden');
      } else {

        if (document.querySelector('header-eazy').classList.contains('open')) {
          if (window.innerWidth >= 640) {
            document.querySelector('.js--header-menu__desktop__button').click();
          } else {
            document.querySelector('.js--header-menu__mobile__button').click();
          }
        }
        if (that.headerFullCart.classList.contains('open')) {
          that.headerFullCart.classList.remove('open');
          document.removeEventListener('click', that.bindOutsideClick); // remove first
          gsap.to(that.headerFullCart, {x: '100%', duration: 0.6});
        } else {
          that.headerFullCart.classList.add('open');
          gsap.to(that.headerFullCart, {
            x: '0%', duration: 0.6, onComplete: function() {
              document.removeEventListener('click', that.bindOutsideClick); // remove first
              setTimeout(() => {
                document.addEventListener('click', that.bindOutsideClick);
              }, 0);

            }
          });
        }
      }
    })

    this.closeButton.addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      that.message.classList.add('hidden');
    })

    window.subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          let length = cart.items.length;
          if (length != 0) {
            that.querySelector('.cart-count-bubble').classList.remove('cart-count-bubble--0');
            that.querySelector('.js--cart-count').innerHTML = length;
          } else {
            that.querySelector('.js--cart-count').innerHTML = '';
            that.querySelector('.cart-count-bubble').classList.add('cart-count-bubble--0');
          }
          that.headerFullCart.classList.add('open');
          gsap.to(that.headerFullCart, {
            x: '0%', duration: 0.6, onComplete: function() {
              document.removeEventListener('click', that.bindOutsideClick); // remove first
              setTimeout(() => {
                document.addEventListener('click', that.bindOutsideClick);
              }, 0);

            }
          });
        })
    })

    const urlParams = new URLSearchParams(window.location.search);
    const cartParam = urlParams.get('cart');
    if (cartParam == 1) {
      console.log(this.querySelector('a'));
   
if (!(that.headerFullCart.classList.contains('open'))) {
      that.headerFullCart.classList.add('open');
      gsap.to(that.headerFullCart, {
        x: '0%', duration: 0.6, onComplete: function() {
          document.removeEventListener('click', that.bindOutsideClick); // remove first
          setTimeout(() => {
            document.addEventListener('click', that.bindOutsideClick);
          }, 0);

        }
      });
    }
    }


  }

  clickOutsideCart(e) {
    let that = this;
    // console.log(that.cartButton);
    console.log('click outside');
    if (that.headerFullCart.classList.contains('open') && (!that.cartButton.contains(e.target)) && (!(that.headerFullCart.contains(e.target)))) {
      console.log('removing');
      that.headerFullCart.classList.remove('open');
      document.removeEventListener('click', this.bindOutsideClick);
      gsap.to(that.headerFullCart, {x: '100%', duration: 0.6});
    }
  }
}

customElements.define("header-cart", HeaderCart);


  class CollectionProductGrid extends HTMLElement {

    constructor() {
      super();
      let that = this;


      this.querySelector('.js--swatch').addEventListener('click', function(e) {
        if (that.querySelector('.js--swatch').classList.contains('open')) {
          that.querySelector('.js--swatch').classList.remove('open');
          window.removeEventListener('click', detectOutsideClick);
          gsap.to(document.querySelector('.c--color-wrapper'), {x: '101%', right: '0', duration: 0.7});

        } else {


          if (that.querySelector('filter-toggle button').classList.contains('open')) {
            that.querySelector('filter-toggle button').click();
          }

          if (that.querySelector('.js--text-swatch').classList.contains('open')) {
            that.querySelector('.js--text-swatch').classList.remove('open');
            window.removeEventListener('click', detectOutsideClickText);
            gsap.to(document.querySelector('.c--color-wrapper-text'), {x: '101%', right: '0', duration: 0.7});
          }
          that.querySelector('.js--swatch').classList.add('open');
          gsap.to(document.querySelector('.c--color-wrapper'), {
            x: '0%', right: '0', duration: 0.7, onStart: function() {
              window.addEventListener('click', detectOutsideClick);
            }
          });

        }
      })

      function detectOutsideClick(e) {
        console.log('deteecting');
        console.log(e.target);
        if (!e.target.closest('.c--color-wrapper')) {
          that.querySelector('.js--swatch').classList.remove('open');
          window.removeEventListener('click', detectOutsideClick);
          gsap.to(document.querySelector('.c--color-wrapper'), {x: '101%', right: '0', duration: 0.7});
        }
      }

      function detectOutsideClickText(e) {
        console.log('deteecting');
        console.log(e.target);
        if (!e.target.closest('.c--color-wrapper-text ')) {
          that.querySelector('.js--text-swatch').classList.remove('open');
          window.removeEventListener('click', detectOutsideClickText);
          gsap.to(document.querySelector('.c--color-wrapper-text'), {x: '101%', right: '0', duration: 0.7});
        }
      }

      var backgroundPicker = new Picker({
        parent: document.querySelector('.c--color-wrapper'),
        color: '#F6F6F6A6',
        popup: false,
        // parent: document.querySelector('.c--color-menu-wrapper'),
        onChange: function(color) {
          console.log(color);
          that.querySelector('.js--swatch').style.backgroundColor = color.rgbaString;
          document.querySelectorAll('.card-wrapper').forEach((card) => {
            gsap.to(card, {backgroundColor: color.rgbaString, duration: 0});
          })
        }
      });


      this.querySelector('.js--text-swatch').addEventListener('click', function(e) {
        console.log('text click');
        if (that.querySelector('.js--text-swatch').classList.contains('open')) {
          that.querySelector('.js--text-swatch').classList.remove('open');
          window.removeEventListener('click', detectOutsideClickText);
          gsap.to(document.querySelector('.c--color-wrapper-text'), {x: '101%', right: '0', duration: 0.7});
        } else {
          if (that.querySelector('filter-toggle button').classList.contains('open')) {
            that.querySelector('filter-toggle button').click();
          }
          if (that.querySelector('.js--swatch').classList.contains('open')) {
            that.querySelector('.js--swatch').classList.remove('open');
            window.removeEventListener('click', detectOutsideClick);
            gsap.to(document.querySelector('.c--color-wrapper'), {x: '101%', right: '0', duration: 0.7});
          }
          that.querySelector('.js--text-swatch').classList.add('open');
          gsap.to(document.querySelector('.c--color-wrapper-text'), {
            x: '0%', right: '0', duration: 0.7, onStart: function() {
              window.addEventListener('click', detectOutsideClickText);
            }
          });
        }
      })


      var textPicker = new Picker({
        parent: document.querySelector('.c--color-wrapper-text'),
        color: 'black',
        popup: false,
        onChange: function(color) {
          // that.querySelector('.js--text-swatch').style.color = color.rgbaString;
          that.querySelector('.js--text-swatch').style['-webkit-text-stroke'] = '1px ' + color.rgbaString;

          document.querySelectorAll('.card-wrapper').forEach((card) => {
            gsap.to(card.querySelector('.product-title'), {color: color.rgbaString, duration: 0});
          })
        },
      });


      let buttonToWatch = document.querySelector('filter-toggle button');
      // console.log(this.dataset);
      if (this.dataset.disableScrolltrigger !== '1') {
        ScrollTrigger.create({
          trigger: this,
          start: 'top bottom',
          end: 'bottom top',
          onToggle: (self) => console.log('toggled, isActive:', self.isActive),
          onUpdate: (self) => {
            // if ((self.progress <= 0.20) && (buttonToWatch.classList.contains('open'))) {
            //   buttonToWatch.click();
            // }
            // if ((self.progress >= 0.80) && (buttonToWatch.classList.contains('open'))) {
            //   buttonToWatch.click();
            // }

            let swatchEl = that.querySelector('.js--swatch');
            if ((self.progress > 0.90) && (swatchEl.classList.contains('open'))) {
              swatchEl.click();
            }

            let swatchTextEl = that.querySelector('.js--text-swatch');
            if ((self.progress > 0.90) && (swatchTextEl.classList.contains('open'))) {
              swatchTextEl.click();
            }

            let distance = buttonToWatch.getBoundingClientRect().top;

            if (window.innerWidth < 1300) {
              distance = distance - 70;
            }
            if ((self.progress > 0.90) && (buttonToWatch.classList.contains('open'))) {
              buttonToWatch.click();
            }
            if (self.progress <= 0.90) {
              // console.log(distance);
              gsap.to('.c--facets-menu-wrapper', {y: distance - 22, duration: 0.1});
              gsap.to('.c--color-wrapper', {y: distance - 22, duration: 0.1});
              gsap.to('.c--color-wrapper-text', {y: distance - 22, duration: 0.1});
            }
          }
        });
      }


    }
  }

  customElements.define("collection-product-grid", CollectionProductGrid);


  class HomeAnimation extends HTMLElement {

    constructor() {
      super();
      let that = this;

      this.innerHeight = 300;
      // let tl = gsap.timeline();
      // tl.to('home-animation .a--intro-wrapper', {marginTop:0, duration:0.4});
      // tl.to('home-animation .a--intro-bg', {opacity:1},'-=0.4' );
      // tl.to('home-animation .a--intro-letter', {opacity:1, duration:0.8, stagger:0.2},'-=0.2' );
      // tl.set('home-animation .a--intro-orb', { opacity:1, duration:0}, '-=1.2');
      // tl.to('home-animation .a--intro-orb', { top:0, y:0, ease: "bounce.out",duration:2.5}, '-=1.2');
      // tl.play();

      let height = document.querySelector('home-animation').offsetHeight;

      let tween = gsap.to(this, {
        height: `${window.innerHeight * 3}`,
        scrollTrigger: {
          trigger: this,
          scrub: true,
          start: 'top top', // when the top of the trigger hits the top of the viewport
          end: `${window.innerHeight * 5} top`,
        }
      })


      // ScrollTrigger.create({
      //   trigger: 'home-animation',
      //   scrub: true,
      //   once: true,
      //   pin: true,
      //   pinSpacing: true,
      //   start: 'top top', // when the top of the trigger hits the top of the viewport
      //   end: `${window.innerHeight} top`,
      //   onLeave: (s) => {
      //     // document.querySelector('home-animation').remove();
      //   // s.kill(true, true);
      //   // s.animation.progress(1);
      //   // s.scroll(s.start);
      // },

      // })

// console.log(height);
//     let tlShrink = gsap.timeline({
//       onComplete: function() {
//       gsap.set('home-animation', {height:0});
//       },
//       scrollTrigger: {
//         		trigger: '.trigger',
//             scrub:true,
//             once:true,
//             pin:false,
//             pinSpacing: true,
// 		start: 'top top', // when the top of the trigger hits the top of the viewport
//     end:"bottom top"
//       }
//     });
      // tlShrink.to('home-animation .a--intro-wrapper', {scale: 176 / document.querySelector('.a--intro-wrapper').offsetWidth, duration:1});
      // tlShrink.to('home-animation', {height:0, duration:1});
// tlShrink.to('.a--intro-padding', { paddingTop:0, paddingBottom:0, duration:1},'-=1');

      // tlShrink.to('.a--intro-padding', {paddingTop: 22, paddingBottom:22},'-=1');

    }
  }

// customElements.define("home-animation", HomeAnimation);


// class HomeAnimationFixed extends HTMLElement {

//   constructor() {
//     super();
//     let that = this;

//     gsap.set('.letter', {
//       translateZ: document.querySelector('.c--globe').offsetWidth * 48 / 100
//     })

//     let tl = gsap.timeline();

//     tl.fromTo('home-animation-fixed .a--intro-wrapper', {opacity: 0, y: '100%'}, {opacity: 1, y: 0, duration: 1});
//     tl.to('home-animation-fixed .a--intro-letter', {opacity: 1, duration: 0.8, stagger: 0.2});

// tl.set('.a--intro-fonts', {opacity: 1, duration: 0}, '-=1.2');
// tl.to('.a--intro-fonts', {top: 0, y: 0, opacity:1, ease: "bounce.out", duration: 2.5}, '-=1.2');


//     tl.play();


//     let tlShrink = gsap.timeline({
//       onComplete: function() {
//         // document.querySelector('home-animation').remove();
//         gsap.to('.js--header-menu__desktop', {top: 22, y: 0, duration: 1});
//       },
//       scrollTrigger: {
//         trigger: '#MainContent',
//         // endTrigger: 'body',
//         scrub: true,
//         once: false,
//         pin: true,
//              anticipatePin: true,
//         start: 'top top', // when the top of the trigger hits the top of the viewport
//         end: `${window.innerHeight}`,
//         invalidateOnRefresh: true,
//         // end: "+=3500",
//         onToggle: ({progress, direction, isActive}) => {
//           // ScrollTrigger.refresh();
//           // console.log('on leave');
//         }

//       }
//     });

//     tlShrink.to('home-animation-fixed .a--intro-wrapper', {width: 154, duration: 1});
//     tlShrink.to('#MainContent > section', {marginTop: 84, duration:1},'-=1');

//   }
// }


  class HomeAnimationFixed extends HTMLElement {

    constructor() {
      super();

      let that = this;

      gsap.set('.letter', {
        translateZ: document.querySelector('.c--globe').offsetWidth * 48 / 100
      })

      let tl = gsap.timeline();

      tl.fromTo('home-animation-fixed .a--intro-wrapper', {opacity: 0, y: '100%'}, {
        opacity: 1, y: 0, duration: 1, onComplete: function() {

          gsap.fromTo('html.template-index #MainContent', {y: 50, opacity: 0}, {y: 0, opacity: 1});
          document.querySelectorAll('font-animation').forEach(function(el) {
            el.classList.remove('animate--slide-in');
          })
        }
      });
      tl.to('home-animation-fixed .a--intro-letter', {opacity: 1, duration: 1, stagger: 0.3});

      tl.set('.a--intro-fonts', {opacity: 1, duration: 0}, '-=2');

      tl.to('.a--intro-fonts', {top: 0, y: 0, opacity: 1, ease: "bounce.out", duration: 2}, '-=1');
      tl.to('.a--intro-r', {opacity: 1, duration: 1.5});

      tl.play();

      if (window.innerWidth >= 768) {
        let tlShrink;
        let st;

        function initAnimation() {
          if (st) {
            st.kill(true, true);
            st = null;
          }

          if (tlShrink) {
            tlShrink.kill();
            tlShrink = null;
          }

          // Reset element state completely
          gsap.set('home-animation-fixed .a--intro-wrapper', {clearProps: 'all'});
          gsap.set('home-animation-fixed', {clearProps: 'all'});

          window.scrollTo({top: 0, behavior: 'instant'});

          requestAnimationFrame(() => {
            ScrollTrigger.refresh();

            tlShrink = gsap.timeline({});
            tlShrink.to('home-animation-fixed .a--intro-wrapper', {width: 162, duration: 1, ease: "none"});
            tlShrink.pause();

            st = ScrollTrigger.create({
              trigger: ".gsap-wrapper",
              start: "top top",
              end: "+=1500",
              pin: true,
              animation: tlShrink,
              scrub: true,
              markers: false,
              once: true,
              onLeave: (self) => {
                let pinDistance = self.end - self.start,
                  scroll = self.scroll() - pinDistance;
                self.kill(true, true);
                tlShrink.progress(1);
                self.scroll(scroll);
                ScrollTrigger.refresh();
                gsap.set('home-animation-fixed', {height: 61});
                document.querySelector('home-animation-fixed .a--intro-wrapper').style.position = 'fixed';
                gsap.to('.js--header-menu__desktop', {top: 22, y: 0, duration: 1});
              },
            });
          });
        }

        initAnimation();

        let resizeTimer;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(initAnimation, 200);
        });
      }

    }
  }

  customElements.define("home-animation-fixed", HomeAnimationFixed);


  class TextSectionScaling extends HTMLElement {

    constructor() {
      super();
      let that = this;
      this.weightTable = [];
      this.weightTable['100'] = 'Thin';
      this.weightTable['200'] = 'Extra Light';
      this.weightTable['300'] = 'Light';
      this.weightTable['400'] = 'Regular';
      this.weightTable['500'] = 'Medium';
      this.weightTable['600'] = 'Semibold';
      this.weightTable['700'] = 'Bold';
      this.weightTable['800'] = 'Extrabold';
      this.weightTable['900'] = 'Black';


      // console.log(this.dataset.klaviyo);
      if (this.dataset.klaviyo !== undefined) {

        this.addEventListener('click', function(e) {

          // document.querySelector('#app-embed-container-992035').classList.add('show');
          
if (!(e.target.classList.contains('js--eazy-form'))) {
          that.querySelector('.js--eazy-form').classList.remove('invisible');
          that.querySelector('.js--eazy-form').classList.remove('pointer-events-none');
          }
        
        });
      }


      // console.log(this.weightTable);
      // let currentPixelSize = this.querySelector('p').getPropertyValue('font-size');
      let currentPixelSize = 0;
      let currentLineHeight = 0;
      if (that.querySelector('p')) {
        currentPixelSize = window.getComputedStyle(that.querySelector('p')).fontSize.replace('px', '');
        currentLineHeight = window.getComputedStyle(that.querySelector('p')).lineHeight.replace('px', '');
      } else {
        console.log(that.querySelector('.c--text-section__text__inner'));
        currentPixelSize = window.getComputedStyle(that.querySelector('.c--text-section__text__inner')).fontSize.replace('px', '');
        currentLineHeight = window.getComputedStyle(that.querySelector('.c--text-section__text__inner')).lineHeight.replace('px', '');
      }
      console.log(currentPixelSize, currentLineHeight);
      that.resizeText(currentPixelSize, currentLineHeight);

      let windowWidth = window.innerWidth;

      window.addEventListener('resize', function(event) {
        if (window.innerWidth != windowWidth) {
          that.resizeText(currentPixelSize, currentLineHeight);
          // Affecting buy section scrolltriggers
          // alert('refreshing trigger');
          ScrollTrigger.refresh();
          windowWidth = window.innerWidth;
        }
      });

      setTimeout(function() {
        ScrollTrigger.refresh();
      }, 500);


    }

    resizeText(currentPixelSize, currentLineHeight) {
      let that = this;
      // console.log(this.weightTable);
      let weight = this.weightTable[that.querySelector('.c--pixel-size').getAttribute('data-weight')];

      let style = that.querySelector('.c--pixel-size').getAttribute('data-style');
      style = style.charAt(0).toUpperCase()
        + style.slice(1)
      let preText = weight;
      if (style != 'Normal') {
        preText = weight + ' ' + style;
      }
      let text = that.querySelector('.c--pixel-size').getAttribute('data-text');
      if (window.innerWidth <= 640) {
        gsap.to(that.querySelector('p'), {fontSize: ''});
        let newFontSize = currentPixelSize;
        let newLineHeight = Math.round(currentLineHeight);
        // console.log(newFontSize);
        gsap.to(that.querySelectorAll('.c--text-section__text__inner p'), {fontSize: newFontSize, lineHeight: newLineHeight + 'px', '--lh': newLineHeight + 'px'});
        // that.querySelector('.c--pixel-size').innerHTML = '<span>' + preText + ' ' + (newFontSize + 'px') + (text != '' ? '</span> <span class="c--pixel-size__dash">/</span> ' + '<span>' + text + '</span>' : '') + '</span>';
        if (that.querySelector('.c--pixel-size__js')) {
          that.querySelector('.c--pixel-size__js').innerHTML = '<span>' + preText + ' ' + (newFontSize + 'px') + '</span>';
        }
      } else {
        let scaleFactor = 0.9 * window.innerWidth / 1200;
        let newFontSize = Math.round(scaleFactor * currentPixelSize);
        let newLineHeight = Math.round(scaleFactor * currentLineHeight);
        // console.log(newLineHeight);
        gsap.to(that.querySelectorAll('.c--text-section__text__inner p'), {fontSize: newFontSize, lineHeight: newLineHeight + 'px', '--lh': newLineHeight + 'px'});
        // that.querySelector('.c--pixel-size').innerHTML = preText + ' ' + (newFontSize + 'px') + (text != '' ? ' / ' + text : '');
        if (that.querySelector('.c--pixel-size__js')) {
          that.querySelector('.c--pixel-size__js').innerHTML = '<span>' + preText + ' ' + (newFontSize + 'px') + '</span>';
        }
      }

    }
  }

  customElements.define("text-section-scaling", TextSectionScaling);


  class TypeTesterWrapper extends HTMLElement {

    constructor() {
      super();
      let that = this;

      this.stopScaling = false;

      document.addEventListener('paste', function(e) {
        const text_only = document.getSelection().toString();
        const clipdata = e.clipboardData || window.clipboardData;
        clipdata.setData('text/plain', text_only);
        clipdata.setData('text/html', text_only);
        // e.preventDefault();
      });

      that.querySelector('.c--type-tester__input').addEventListener("paste", (event) => {
        event.preventDefault();

        let paste = (event.clipboardData || window.clipboardData).getData("text");
        // paste.setData('text/plain', paste);
        // paste.setData('text/html', paste);
        const selection = window.getSelection();
        if (!selection.rangeCount) {
          return;
        }
        selection.deleteFromDocument();
        selection.getRangeAt(0).insertNode(document.createTextNode(paste));
        selection.collapseToEnd();
      });

      let initialSize;
      let initialLineHeight;
      let initialLetterSpacing;
      let initialLetterSpacingInput;

      let scale = window.innerWidth < 768 ? 50 : 30;
      let memorizedColor = '#ffffff57';
      this.isScaling = false;
      let widthButton = document.querySelector('.js--show-type-tester__button').clientWidth;
      let scaleFactor = 1;
      if (widthButton > 100) {
        scaleFactor = 0.45;
      }

      let savedInitialText = this.querySelector('.c--type-tester__input').textContent.replace(/<(.|\n)*?>/g, '').trim();

      this.querySelector('.js--show-type-tester__button').addEventListener('click', function() {
        gsap.to(that.querySelector('.js--show-type-tester__button'), {
          force3D: false,
          scale: scaleFactor * window.innerHeight / scale, duration: 1, onComplete: function() {

            let dotsArray = ["| ..", "| .", "|", ""];
            dotsArray.forEach((element, index) => {
              setTimeout(function() {
                console.log(element);
                that.querySelector('.js--show-type-tester__button').innerHTML = element;
              }, 100 * index);
            });
          }
        });
        let padding = 15;
        if (window.innerWidth >= 768) {
          padding = 40;
        }
        gsap.to(that, {
          height: 'calc(100% - ' + padding + 'px)',
          width: 'calc(100% - 40px)',
          borderRadius: '19px',
          duration: 0.4,
          onComplete: function() {

            setTimeout(function() {

              that.doEventListeners();
              that.scaleText();


              let text = that.querySelector('.c--type-tester__input').innerHTML;
              // console.log(text);
              // console.log(split);
              // that.querySelector('.c--type-tester__input').innerText = '';
              // split.chars.forEach(function(el, index) {
              //   setTimeout(function() {
              //     that.querySelector('.c--type-tester__input').innerText = that.querySelector('.c--type-tester__input').innerText + el.innerText;
              //   },index * 100);
              // })

              let textArray = that.querySelector('.c--type-tester__input').textContent.replace(/<(.|\n)*?>/g, '').trim().split("");
              // console.log(textArray);

              // let split = SplitText.create(that.querySelector('.c--type-tester__input'));
              // console.log(split.chars);

              that.querySelector('.c--type-tester__input').innerHTML = '';
              textArray.forEach((element, index) => {
                setTimeout(function() {
                  // console.log(element);

                  that.querySelector('.c--type-tester__input').innerHTML += element;
                  that.scaleText();

                  if (index == textArray.length - 1) {
                    gsap.set(that.querySelector('buy-button'), {opacity: 0});
                    that.querySelector('buy-button').classList.remove('invisible');
                    gsap.fromTo(that.querySelector('buy-button'), {opacity: 0}, {opacity: 1, duration: 1});

                    gsap.set('.js--close-type-tester', {opacity: 0});
                    that.querySelector('.js--close-type-tester').classList.remove('invisible');
                    gsap.fromTo('.js--close-type-tester', {opacity: 0}, {opacity: 1, duration: 1});

                    gsap.set('.c--font-name', {opacity: 0});
                    that.querySelector('.c--font-name').classList.remove('invisible');
                    gsap.fromTo('.c--font-name', {opacity: 0}, {opacity: 1, duration: 1});

                    gsap.set(that.querySelector('.sample-text-wrapper .settings'), {opacity: 0});
                    that.querySelector('.sample-text-wrapper .settings').classList.remove('invisible');
                    gsap.fromTo(that.querySelector('.sample-text-wrapper .settings'), {opacity: 0}, {opacity: 1, duration: 1});

                    const compStyles = window.getComputedStyle(that.querySelector(".c--type-tester__input"));

                    initialSize = compStyles.getPropertyValue("font-size");
                    initialLineHeight = compStyles.getPropertyValue("line-height");

                    initialLetterSpacing = compStyles.getPropertyValue("letter-spacing");
                    initialLetterSpacingInput = that.querySelector(".settings .letter-spacing input").value;

                  }


                }, 50 * index);


              });

              gsap.to(that.querySelector('type-tester'), {backgroundColor: memorizedColor});


// let split = SplitText.create(that.querySelector('.c--type-tester__input'), { autoSplit: true, type: "chars", smartWrap: true,
//               onSplit(self) {
//                 return gsap.fromTo(self.chars, { // a returned animation gets cleaned up and time-synced on each onSplit() call
//                   display: 'none',
//                   opacity:0
//                 }, {
//                   display:'inline-block',
//                   duration:0.05,
//                   opacity:1,
//                   stagger: 0.10,
//                   onSplit: () => {
//                     that.scaleText();
//                   },
//                   onComplete: () => { 
//                     self.revert() // revert the element to its original (unsplit) state
//                     gsap.set(that.querySelector('buy-button'), {opacity: 0});
//                     that.querySelector('buy-button').classList.remove('invisible');
//                     gsap.fromTo(that.querySelector('buy-button'), {opacity: 0}, {opacity: 1, duration:1});

//                     gsap.set('.js--close-type-tester', {opacity: 0});
//                     that.querySelector('.js--close-type-tester').classList.remove('invisible');
//                     gsap.fromTo('.js--close-type-tester', {opacity: 0}, {opacity: 1, duration:1});

//                     gsap.set('.c--font-name', {opacity: 0});
//                     that.querySelector('.c--font-name').classList.remove('invisible');
//                     gsap.fromTo('.c--font-name', {opacity: 0}, {opacity: 1, duration:1});

//                     gsap.set(that.querySelector('.sample-text-wrapper .settings'), {opacity: 0});
//                     that.querySelector('.sample-text-wrapper .settings').classList.remove('invisible');
//                     gsap.fromTo(that.querySelector('.sample-text-wrapper .settings'), {opacity: 0}, {opacity: 1, duration:1});

//                   }
//                 });
//               }
//              });


              that.querySelector('.js--show-type-tester__button').classList.add('hidden');
              that.querySelector('.js--show-type-tester__button').innerHTML = "<span class=\"js--show-type-tester__blink\">|</span> ...";
              that.querySelector('type-tester').classList.remove('invisible');

            }, 600);


          }
        })
        // gsap.set('type-tester', {opacity: 0});
        // that.querySelector('type-tester').classList.remove('invisible');
        // gsap.fromTo('type-tester', {opacity: 0, filter: "blur(100px)"}, {opacity: 1, filter: "blur(0px)"});
      })

      this.querySelector('.js--close-type-tester').addEventListener('click', function() {
        // gsap.fromTo('type-tester', {opacity: 1, filter: "blur(0px)"}, {
        //   opacity: 0, filter: "blur(100px)", onComplete: function() {
        //     that.querySelector('type-tester').classList.add('invisible');
        //   }
        // });
        let timeline = gsap.timeline();


        let textSaved = that.querySelector('.c--type-tester__input').innerHTML;
        console.log(textSaved);
        if (that.querySelector('.c--type-tester__input').textContent.replace(/<(.|\n)*?>/g, '').trim() == '') {
          textSaved = savedInitialText;
        }
        console.log(textSaved);
        
        let textToRemove = that.querySelector('.c--type-tester__input').textContent.replace(/<(.|\n)*?>/g, '').trim().split("");

        let textToRemoveSteps = [];
        let length = textToRemove.length;
        for (let i = 0; i < length; i++) {
          console.log(i);

          let poppedArrayDone = textToRemove.pop();
          textToRemoveSteps.push(textToRemove.join(""));
        }
        console.log(textToRemoveSteps);

        if (textToRemoveSteps.length == 0) {
          that.querySelector('.js--show-type-tester__button').classList.remove('hidden');
          that.querySelector('type-tester').classList.add('invisible');
        } else {
          textToRemoveSteps.forEach((element, index) => {
            setTimeout(function() {
              console.log(element);
              that.querySelector('.c--type-tester__input').innerHTML = element;
              // that.scaleText();
              if (index == length - 1) {
                that.querySelector('.js--show-type-tester__button').classList.remove('hidden');
                that.querySelector('type-tester').classList.add('invisible');
              }

            }, 40 * index);
          });
        }


        let dotsArray = ["| ...", "| ..", "| .", "|"].reverse();
        dotsArray.forEach((element, index) => {
          setTimeout(function() {
            console.log(element);
            that.querySelector('.js--show-type-tester__button').innerHTML = element;
          }, 40 * length + 4 + 75 * index);
        });


        gsap.to(that.querySelector('type-tester'), {backgroundColor: '#ffffff57'});

        setTimeout(function() {

          that.querySelector('.c--type-tester__input').innerHTML = textSaved;
          that.querySelector('.js--show-type-tester__button').innerHTML = "<span class=\"js--show-type-tester__blink\">|</span> ...";
          gsap.to(that.querySelector('buy-button'), {duration: 0.2, opacity: 0});
          gsap.to('.js--close-type-tester', {duration: 0.2, opacity: 0});
          gsap.to('.c--font-name', {opacity: 0, duration: 0.2, opacity: 0});
          gsap.to(that.querySelector('.sample-text-wrapper .settings'), {opacity: 0, duration: 0.2, opacity: 0});

          gsap.to(that.querySelector('.js--show-type-tester__button'), {scale: 1, duration: 0.4});
          gsap.to(that, {
            height: 'auto',
            width: 'auto',
            borderRadius: '40px',
            duration: 0.4
          });
        }, 40 * (length + 4) + 75 * 3);


      });

      setInterval(function() {
        if (that.querySelector('.js--show-type-tester__blink')) {
          that.querySelector('.js--show-type-tester__blink').classList.toggle('invisible');
        }
      }, 600);


      this.scaleText();


      window.addEventListener("resize", () => {
        this.scaleText();
      });

      document.fonts?.ready.then(() => {
        this.scaleText();
      });

      const textEl = this.querySelector(".c--type-tester__input");

      const textElWrapper = this.querySelector('.c--type-tester-wrapper');

      this.querySelector('.c--reset').addEventListener('click', function() {
        textEl.style.fontSize = initialSize;
        that.querySelector(".settings .font-size input").value = initialSize.replace('px', '');
        ;
        that.querySelector(".settings .font-size .showcase").innerHTML = initialSize;


        textElWrapper.style.letterSpacing = initialLetterSpacing;
        that.querySelector(".settings .letter-spacing input").value = initialLetterSpacingInput;
        that.querySelector(".settings .letter-spacing .showcase").innerHTML = initialLetterSpacingInput;


        textElWrapper.style.lineHeight = initialLineHeight;
        let sliderLineHeight = initialLineHeight.replace('px', '') / initialSize.replace('px', '');
        that.querySelector(".settings .line-height input").value = sliderLineHeight;
        that.querySelector(".settings .line-height .showcase").innerHTML = sliderLineHeight;


        console.log('reset');
      })

      textEl.addEventListener('input', function() {
        // console.log('SCALING FUNCTION');

        that.scaleText();


        let newSize = textEl.style.fontSize.replace('px', '');

        // if (((initialSize - newSize) / initialSize) * 100 > 10) {
        //     // if we go above 10% change, we add a line break
        //     var lastIndex = textEl.innerHTML.lastIndexOf(" ");
        //     textEl.innerHTML = textEl.innerHTML.substr(0, lastIndex) + '<br/>' + textEl.innerHTML.substr(lastIndex + 1);
        // }

      })

      if (this.querySelector('.js--weight-button')) {
        this.querySelector('.js--weight-button').addEventListener('click', function() {
          that.querySelector('.js--weight-menu').classList.toggle('hidden');
          that.querySelector('.js--weight-button .svg-wrapper').classList.toggle('rotate-180');
        })


        this.querySelectorAll('.js--font-weight-style').forEach(element => {
          element.addEventListener('click', function() {
            // console.log('clicked');
            let weight = element.dataset.fontWeight;
            let style = element.dataset.fontStyle;
            textEl.style.fontWeight = weight;
            textEl.style.fontStyle = style;

            that.querySelector('.js--weight-menu').classList.add('hidden');
            that.querySelector('.js--weight-button .svg-wrapper').classList.add('rotate-180');
            that.querySelector('.js--weight-button .font-weight-name').innerHTML = element.innerHTML;
            // that.scaleText();


          })
        });
      }


      if (this.querySelector('.js--alternates-button')) {
        this.querySelector('.js--alternates-button').addEventListener('click', function() {
          that.doAlternates();
          that.querySelector('.js--alternates-menu').classList.toggle('hidden');
          that.querySelector('.js--alternates-button .svg-wrapper').classList.toggle('rotate-180');
        })
        this.querySelectorAll('.js--alternates-style').forEach(function(el, index) {
          el.addEventListener('click', function() {
            console.log(el.dataset);
            if (el.classList.contains('active')) {
              el.classList.remove('active');
            } else {
              if (el.dataset.exclusive == '1') {
                // can be the only alternate, we remove the others
                that.querySelectorAll('.js--alternates-style').forEach(function(subEl, subIndex) {
                  subEl.classList.remove('active');
                });
              }
              el.classList.add('active');
            }
            that.doAlternates();
          })
        });
      }


      var backgroundPicker = new Picker({
        parent: this.querySelector('.js--swatch'),
        color: '#ffffff57',
        popup: 'top',

        onChange: function(color) {
          console.log(color);
          memorizedColor = color.rgbaString;
          that.querySelector('.js--swatch div').style.backgroundColor = color.rgbaString;
          that.querySelector('type-tester').style.backgroundColor = color.rgbaString;
          // if (that.querySelector('.picker_done')) {
          // that.querySelector('.picker_done').innerText = 'hello';
          // }
          // myParentElement.style.backgroundColor = color.rgbaString;
        },
      });

      var textPicker = new Picker({
        parent: this.querySelector('.js--text-swatch'),
        color: 'black',
        popup: 'top',
        onChange: function(color) {
          that.querySelector('.js--text-swatch').style.color = color.rgbaString;
          textEl.style.color = color.rgbaString;
          // myParentElement.style.backgroundColor = color.rgbaString;
        },
      });


    }


    doAlternates() {
      const textEl = this.querySelector(".c--type-tester__input");
      let alternateString = '';
      this.querySelectorAll('.js--alternates-style').forEach(function(el, index) {
        if (index !== 0) {
          alternateString += ", ";
        }
        let alternate = el.dataset.alternate;
        if (el.classList.contains('active')) {
          alternateString += '"' + alternate + '"';
        } else {
          alternateString += '"' + alternate + '"' + " 0";
        }
      })
      // textEl.style.fontFeatureSettings = '"ss01", "ss02" 0, "ss03" 0, "ss04" 0, "ss05" 0, "ss06" 0, "ss20" 0, "salt" 0, "liga", "dlig" 0, "tnum" 0, "pnum" 0, "ordn" 0, "frac" 0, "sinf" 0, "subs" 0, "sups" 0, "case" 0';
      // console.log(alternateString);
      textEl.style.fontFeatureSettings = alternateString;
      // this.scaleText();
    }

    fitTextToParent(textEl, parentEl, min = 5, max = 100000) {
      // console.log('calling fit');
      let low = min;
      let high = max;
      let best = min;

      textEl.style.width = "fit-content";
      // textEl.style.width= "max-content";
      // textEl.style.whiteSpace = "nowrap";
      textEl.style.display = "inline-block";

      const computedParent = getComputedStyle(parentEl);
      const parentPaddingTop = parseFloat(computedParent.paddingTop) || 0;
      const parentPaddingBottom = parseFloat(computedParent.paddingBottom) || 0;
      const parentPaddingLeft = parseFloat(computedParent.paddingLeft) || 0;
      const parentPaddingRight = parseFloat(computedParent.paddingRight) || 0;

      const computedText = getComputedStyle(textEl);
      const textPaddingTop = parseFloat(computedText.paddingTop) || 0;
      const textPaddingBottom = parseFloat(computedText.paddingBottom) || 0;
      const textPaddingLeft = parseFloat(computedText.paddingLeft) || 0;
      const textPaddingRight = parseFloat(computedText.paddingRight) || 0;

      const parentHeight = parentEl.clientHeight - parentPaddingTop - parentPaddingBottom;
      const parentWidth = parentEl.clientWidth - parentPaddingLeft - parentPaddingRight;
      // console.log(parentEl.clientHeight);
      let lineBreaks = textEl.getElementsByTagName('br').length;

      let count = 0;
      while (low <= high) {
        // console.log('looping ' + low, high);
        // if (count == 50) {
        //   break;
        // }
        count++;
        const mid = Math.floor((low + high) / 2);
        // console.log(mid);
        // const adjustedMid = mid / lineBreaks;
        const adjustedMid = mid;
        // console.log("TRYING FONT SIZE ", adjustedMid);
        textEl.style.fontSize = `${adjustedMid}px`;
        // adjust in case we have line breaks
        // count the line breaks

        // console.log("NEW TEXT HEIGHT ", textEl.offsetHeight);
        // console.log("NEW PARENT HEIGHT ", parentHeight);


        // let fits = textEl.scrollWidth <= parentWidth;
        let fitsHeight =
          // .querySelector("span")
          textEl.scrollHeight <=
          // +
          //   textPaddingLeft +
          //   textPaddingRight
          parentHeight;
        // console.log('text height ', textEl.offsetHeight);
        // console.log('paren theight ', parentHeight);
        let fitsWidth = textEl.offsetWidth < 1.02 * parentWidth;

        // if (isIOS()) {
        //   // fits = textEl.scrollWidth - mid * 0.25 <= parentWidth;
        //   fits = textEl.scrollWidth - mid * 0.2 <= parentWidth;
        // }

        if (fitsHeight && fitsWidth) {
          best = adjustedMid;
          low = adjustedMid + 1;
        } else {
          high = adjustedMid - 1;
        }
        // console.log(low, high);
      }

      // best -= 1;

      textEl.style.fontSize = `${best}px`;
      // gsap.to(textEl, {fontSize: `${best}px`});

      textEl.style.removeProperty("white-space");

      return best;
    }


    onFontSizeSliderChange(e, parentEl, fontSizeEl) {
      this.stopScaling = true;
      const textEl = parentEl.querySelector(".c--type-tester__input");
      textEl.style.fontSize = e.target.value + "px";

      fontSizeEl.querySelector(".showcase").innerHTML = e.target.value + "px";
    }


    onLetterSpacingSliderChange(e, parentEl, letterSpacingEl) {
      let that = this;
      // const textEl = parentEl.querySelector(".c--type-tester-wrapper");
      let percentage = parseFloat(e.target.value) / 4;
      // parentEl.style.letterSpacing = e.target.value + "rem";
      parentEl.style.letterSpacing = percentage + "%";
      // this.querySelector('.c--type-tester__input').style.marginRight = "-" + e.target.value + "rem";
      console.log(document.querySelector('.c--type-tester__input ').style.fontSize);
      console.log("-" + (parseFloat(e.target.value) * parseFloat(document.querySelector('.c--type-tester__input ').style.fontSize) / 100) + "px");
      parentEl.style.marginRight = (-1 * percentage * parseFloat(document.querySelector('.c--type-tester__input ').style.fontSize) / 100) + "px";
      letterSpacingEl.querySelector(".showcase").innerHTML = e.target.value;
      if (!(that.isScaling)) {
        that.isScaling = true;

        if (!(that.stopScaling)) {
          setTimeout(function() {
            that.scaleText();
            that.isScaling = false;
          }, 1000);
        }
      }

      // this.scaleText();
      // this.scaleText();
    }

    onLineHeightSliderChange(e, parentEl, lineHeightEl) {
      // const textEl = parentEl.querySelector(".c--type-tester-wrapper");
      parentEl.style.lineHeight = e.target.value;

      lineHeightEl.querySelector(".showcase").innerHTML = e.target.value;
      // this.scaleText();
    }

    doEventListeners() {

      const slideEl = this.querySelector(".c--type-tester-wrapper");

      const fontWeightEl = this.querySelector(".settings .font-weight");
      const fontSizeEl = this.querySelector(".settings .font-size");
      const letterSpacingEl = this.querySelector(
        ".settings .letter-spacing"
      );
      const lineHeightEl = this.querySelector(".settings .line-height");

      fontSizeEl.addEventListener("input", (e) =>
        this.onFontSizeSliderChange(e, slideEl, fontSizeEl)
      );
      fontSizeEl.addEventListener("change", (e) =>
        this.onFontSizeSliderChange(e, slideEl, fontSizeEl)
      );

      letterSpacingEl.addEventListener("input", (e) =>
        this.onLetterSpacingSliderChange(e, slideEl, letterSpacingEl)
      );
      letterSpacingEl.addEventListener("change", (e) =>
        this.onLetterSpacingSliderChange(e, slideEl, letterSpacingEl)
      );

      lineHeightEl.addEventListener("input", (e) =>
        this.onLineHeightSliderChange(e, slideEl, lineHeightEl)
      );
      lineHeightEl.addEventListener("change", (e) =>
        this.onLineHeightSliderChange(e, slideEl, lineHeightEl)
      );
    }

    scaleText() {
      // console.log('calling scale');

      const slideEl = this.querySelector(".c--type-tester-wrapper");

      const fontWeightEl = this.querySelector(".settings .font-weight");
      const fontSizeEl = this.querySelector(".settings .font-size");
      const letterSpacingEl = this.querySelector(
        ".settings .letter-spacing"
      );
      const lineHeightEl = this.querySelector(".settings .line-height");

      // fontSizeEl.addEventListener("input", (e) =>
      //   this.onFontSizeSliderChange(e, slideEl, fontSizeEl)
      // );
      // fontSizeEl.addEventListener("change", (e) =>
      //   this.onFontSizeSliderChange(e, slideEl, fontSizeEl)
      // );

      // letterSpacingEl.addEventListener("input", (e) =>
      //   this.onLetterSpacingSliderChange(e, slideEl, letterSpacingEl)
      // );
      // letterSpacingEl.addEventListener("change", (e) =>
      //   this.onLetterSpacingSliderChange(e, slideEl, letterSpacingEl)
      // );

      // lineHeightEl.addEventListener("input", (e) =>
      //   this.onLineHeightSliderChange(e, slideEl, lineHeightEl)
      // );
      // lineHeightEl.addEventListener("change", (e) =>
      //   this.onLineHeightSliderChange(e, slideEl, lineHeightEl)
      // );

      const textEl = slideEl.querySelector(".c--type-tester__input");

      textEl.spellcheck = false;

      const scaleFontSizeUpTo = parseInt(slideEl.dataset.scaleFontSizeUpTo);
      const scaleFontSizeDownTo = parseInt(slideEl.dataset.scaleFontSizeDownTo);

      if (slideEl && textEl) {
        // const isMultiWord = slideEl.dataset.multiWord === "true";
        // if (isMultiWord) {
        //   let initTextSize = parseInt(slideEl.dataset.textSizeDesktop);
        //   if (window.innerWidth <= 767) {
        //     initTextSize = parseInt(slideEl.dataset.textSizeMobile);
        //   }

        //   textEl.style.opacity = "1";

        //   let maxTextSize = initTextSize * 2 - 15;
        //   if (maxTextSize < 60) {
        //     maxTextSize = 60;
        //   }

        //   if (window.innerWidth > 767) {
        //     maxTextSize = scaleFontSizeUpTo;
        //   }

        //   let minTextSize = scaleFontSizeDownTo;

        //   const fontSizeEl = slideEl.querySelector(".font-size");
        //   fontSizeEl.querySelector("span.showcase").innerHTML =
        //     initTextSize + "px";
        //   fontSizeEl.querySelector("input").setAttribute("max", maxTextSize);
        //   fontSizeEl.querySelector("input").setAttribute("min", minTextSize);
        //   fontSizeEl.querySelector("input").value = initTextSize;
        //   return;
        // }

        /* NEW */
        let newFontSize = parseFloat(window.getComputedStyle(textEl).fontSize);
        newFontSize = this.fitTextToParent(textEl, slideEl);

        textEl.style.opacity = "1";

        let maxTextSize = newFontSize + (newFontSize - 16);
        if (maxTextSize < 60) {
          maxTextSize = 60;
        }

        if (window.innerWidth > 767) {
          maxTextSize = newFontSize + scaleFontSizeUpTo;
        }

        const fontSizeEl = this.querySelector(".font-size");
        fontSizeEl.querySelector("span.showcase").innerHTML =
          newFontSize + "px";
        // fontSizeEl.querySelector("input").setAttribute("max", maxTextSize);
        fontSizeEl.querySelector("input").value = newFontSize;
        // gsap.to(fontSizeEl.querySelector("input"), { fontSize: newFontSize});
      }

    }


  }

  customElements.define("type-tester-wrapper", TypeTesterWrapper);


  class EazyFormWrapper extends HTMLElement {

    constructor() {
      super();
      let that = this;
    }
  }

  customElements.define("eazy-form-wrapper", EazyFormWrapper);

 class EazyForm extends HTMLElement {

    constructor() {
      super();
      let that = this;
      this.addEventListener('click', function(e) {
        console.log(e.target);
        console.log(e.target.classList);
        if (e.target.classList.contains('js--eazy-form')) {
          console.log('contains');
          that.classList.add('invisible');
          that.classList.add('pointer-events-none');
        }
      })
    }
  }

  customElements.define("eazy-form", EazyForm);

  
});